import React, { useEffect, useState } from 'react';
import { pick, prop } from 'ramda';

import { Icon } from '@core/js/components/common/Icon';

import { Logo } from '@interlayer/js/app/components/common/Logo';
import { WidgetAccount } from '@interlayer/js/app/components/common/WidgetAccount';
import { EmptyMenu } from '@interlayer/js/app/components/main/DefaultMenu/components/MenuDesktop/components/EmptyMenu';
import { GamesSearchGlobal } from '@interlayer/js/app/components/main/GameSearchGlobal';
import { Button } from '@interlayer/js/components/common/Button';

import { useTranslations } from '@core/js/hooks/i18n';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { noop } from '@core/js/utils/methods.util';

import { useSwitchMobileMenu } from '@interlayer/js/app/components/main/DefaultHeader/components/HeaderMobile/hooks';
import { BUTTON_IDS } from '@interlayer/js/app/components/main/PlayBingoNowButton/constants';
import { useIsLayoutRetailRegistrationWithoutHeader } from '@interlayer/js/app/hooks/menu/useIsLayoutRetailRegistrationWithoutHeader';
import { useIsLayoutWithoutHeader } from '@interlayer/js/app/hooks/menu/useIsLayoutWithoutHeader';
import { useConfigTag } from '@interlayer/js/app/hooks/useConfigTag';
import { useLoginPopup } from '@interlayer/js/components/popups/LoginPopup/hooks';
import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { TJoinNowConfigTagConfig } from '@interlayer/js/components/system/TagManager/buzz/types';

import style from './MenuDesktop.scss';

export const MenuDesktop: React.FC = () => {
    const isLayoutWithoutHeader = useIsLayoutWithoutHeader();
    const isLayoutRetailRegistration = useIsLayoutRetailRegistrationWithoutHeader();
    const showLoginPopup = useLoginPopup();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const t = useTranslations('playtech.mobile.system.header.');
    const switchMobileMenu = useSwitchMobileMenu();
    const { showMobileMenu, rootPage } = useAppSelector(pick(['showMobileMenu', 'rootPage']));
    const [isOpen, setOpen] = useState(showMobileMenu);
    const joinNowConfig = useConfigTag(CONFIG_TAG_TYPE.joinNowConfig) as TJoinNowConfigTagConfig;

    useEffect(() => {
        setOpen(showMobileMenu);
    }, [showMobileMenu]);

    if (isLayoutWithoutHeader) {
        return <EmptyMenu />;
    }

    if (isLayoutRetailRegistration) {
        return null;
    }

    return (
        <div className={style.container}>
            <div className={style.hamburger} onClick={() => switchMobileMenu(!isOpen)}>
                <Icon type="menu_hamburger" />
            </div>

            <div className={style.wrap}>
                <Logo
                    href={rootPage}
                    className={style.logo}
                    size="3.5rem"
                />

                <div className={style.search}>
                    <GamesSearchGlobal />
                </div>

                {isLoggedIn
                    ? (
                        <WidgetAccount setSearchShow={noop} isSearchShow={false} />
                    )
                    : (
                        <div className={style.rightBlock}>
                            <div className={style.btnWrap}>
                                {joinNowConfig?.config?.isEnabled && (
                                    <Button
                                        size="small"
                                        href={joinNowConfig.config.url}
                                        view="secondary"
                                        className={style.btn}
                                    >
                                        {joinNowConfig.config.text}
                                    </Button>
                                )}

                                <Button
                                    size="small"
                                    className={style.btn}
                                    onClick={showLoginPopup}
                                >
                                    {t('login')}
                                </Button>
                            </div>
                        </div>
                    )
                }

                <div id={BUTTON_IDS.PLAY_BINGO_NOW_BUTTON_ID} />
            </div>
        </div>
    );
};

